export const ADMIN_VISIBILITY_FILTER = {
    key: 'visibility',
    label: 'Visibilidad',
    type: 'select',
    options: [
        { value: 'visible', label: 'Visible' },
        { value: 'hidden', label: 'Oculto' },
    ],
    getValues: (item) => [item?.active === false || Number(item?.active) === 0 ? 'hidden' : 'visible'],
};

export const ADMIN_FEATURED_FILTER = {
    key: 'featured_state',
    label: 'Destacado',
    type: 'select',
    options: [
        { value: 'featured', label: 'Destacado' },
        { value: 'normal', label: 'Normal' },
    ],
    getValues: (item) => [item?.featured === true || Number(item?.featured) === 1 ? 'featured' : 'normal'],
};

export const ADMIN_DEFAULT_ORDER = (titleField = 'title') => [
    { value: 'sort-asc', label: 'Orden manual ↑', field: 'sort_order', direction: 'asc', type: 'number' },
    { value: 'sort-desc', label: 'Orden manual ↓', field: 'sort_order', direction: 'desc', type: 'number' },
    { value: 'title-asc', label: 'Nombre A → Z', field: titleField, direction: 'asc', type: 'text' },
    { value: 'title-desc', label: 'Nombre Z → A', field: titleField, direction: 'desc', type: 'text' },
];
